import React from "react";
import DOMPurify from "dompurify";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

// Define prop types
type QuillContentProps = {
  content: string | object; // Accepts a string (HTML or plain text) or an object (e.g., JSON)
};

const TypographyContent: React.FC<QuillContentProps> = ({ content }) => {
  // Function to check if content is HTML
  const isHtmlFormat = (value: string): boolean =>
    /<\/?[a-z][\s\S]*>/i.test(value);

  // Sanitize content if it is HTML
  const sanitizedContent: string | null =
    typeof content === "string" && isHtmlFormat(content)
      ? DOMPurify.sanitize(content)
      : null;

  return (
    <Box>
      {sanitizedContent ? (
        // Render Quill-formatted content
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
      ) : (
        // Handle non-Quill content using Material-UI components

        <Typography
          sx={{
            fontSize: 14,
          }}
          className="ql-editor"
        >
          {content?.toString()}
        </Typography>
      )}
    </Box>
  );
};

export default TypographyContent;

export const TypographyAccountContent: React.FC<QuillContentProps> = ({
  content,
}) => {
  // Function to check if content is HTML
  const isHtmlFormat = (value: string): boolean =>
    /<\/?[a-z][\s\S]*>/i.test(value);

  // Sanitize content if it is HTML
  const sanitizedContent: string | null =
    typeof content === "string" && isHtmlFormat(content)
      ? DOMPurify.sanitize(content)
      : null;

  return (
    <Box>
      {sanitizedContent ? (
        // Render Quill-formatted content
        <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
      ) : (
        // Handle non-Quill content using Material-UI components

        <Typography
          sx={{
            fontSize: 13,
          }}
        >
          {content?.toString()}
        </Typography>
      )}
    </Box>
  );
};
